<template>
  <div class="hello">

    <h1>Choose a language! / Válasszon nyelvet! </h1>
    <b-container fluid class="p-4 bg-dark">
      <b-row>
        <b-col>
          <router-link :to="{ name: 'Information' }">
          <b-img @click="changeLang('en')" style="cursor: pointer;" thumbnail fluid :src="require('../assets/flag_en.png')" alt="english" />
          </router-link>
        </b-col>
        <b-col>
          <router-link :to="{ name: 'Information' }">
          <b-img @click="changeLang('hu')" style="cursor: pointer;" thumbnail fluid :src="require('../assets/flag_hu.png')" alt="hungarian" />
          </router-link>
        </b-col>

      </b-row>
    </b-container>
  </div>
</template>

<script>
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'hello',
  computed: mapState([
    'lang'
  ]),
  methods: mapMutations(['changeLang'])
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style>
h1, h2 {
  font-weight: normal;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #35495E;
}
</style>



// WEBPACK FOOTER //
// src/components/Hello.vue